// extracted by mini-css-extract-plugin
export default {"gallery":"page_gallery__UoD2N","column":"page_column__Sbu1i","imageContainer":"page_imageContainer__z6jNE","spacer":"page_spacer__JsC2L"};